const DIAGRAMS = [
  {
    tag: '事件图解',
    figures: '18 图',
    title: '图解｜连麦对质全程时间轴',
    desc: '谁先说、谁先删、谁又回头补了一句，按秒标轴。',
    steps: ['开场互诉', '中途抢麦', '删帖留痕', '二版声明']
  },
  {
    tag: '声明拆解',
    figures: '8 图',
    title: '图解｜两版声明逐字红线比对',
    desc: '删了什么、改了什么、多出的"我"又在绕什么。',
    steps: ['原版扫入', '去重对齐', '差异标红', '语义归类']
  },
  {
    tag: '数据还原',
    figures: '12 图',
    title: '图解｜直播间"在线数"与员工排班对照',
    desc: '打卡时刻与在线曲线叠一起，异常段一目了然。',
    steps: ['导出排班', '抓取曲线', '错位对齐', '异常标点']
  },
  {
    tag: '话术拆解',
    figures: '6 图',
    title: '图解｜一份报价单里的三次压价',
    desc: '从"预算有限"到"同行更低"，红线标出每次让步。',
    steps: ['首版报价', '两轮试探', '临签压价', '话术还原']
  },
  {
    tag: '评论走向',
    figures: '9 图',
    title: '图解｜删帖后风向的三次反复',
    desc: '顶贴、删评、重发，把讨论热度画成折线看。',
    steps: ['爆点发酵', '删评冷却', '补档再燃', '归于对线']
  },
  {
    tag: '聊天复盘',
    figures: '11 图',
    title: '图解｜合伙人分账"已读不回"全过程',
    desc: '每条消息间隔都标出来，沉默也成了证据。',
    steps: ['主动谈约', '拖延话术', '已读不回', '分账结局']
  }
];

export default function DiagramGallery() {
  return (
    <section id="diagram" className="bg-band">
      <div className="mx-auto max-w-[1360px] px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3 border-b-2 border-ink pb-3">
          <div>
            <div className="flex items-center gap-2">
              <i className="ri-image-line text-xl text-verm" />
              <h2 className="font-display text-xl font-black md:text-2xl">帖子图解 · 一眼看懂</h2>
            </div>
            <p className="mt-1 text-sm text-ink/55">文字太长不想看？每期深扒都配了拆解图，跟着节点滑完即懂。</p>
          </div>
          <a href="#deep-read" className="flex items-center gap-1 text-sm text-ink/60 hover:text-verm">
            图解专区全览 <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {DIAGRAMS.map((d) => (
            <article key={d.title} className="group flex flex-col border border-line bg-paper2 p-4 transition-colors hover:border-verm/45 hover:bg-verm-wash md:p-5">
              <div className="flex items-center justify-between">
                <span className="bg-verm-soft px-1.5 py-0.5 text-[11px] font-semibold text-verm">{d.tag}</span>
                <span className="flex items-center gap-1 text-xs text-ink/45">
                  <i className="ri-image-2-line" /> {d.figures}
                </span>
              </div>
              <h3 className="font-display mt-3 text-lg font-black leading-snug group-hover:text-verm">
                <a href="#diagram" className="hover:text-verm">{d.title}</a>
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-ink/60">{d.desc}</p>

              {/* 拆解轨迹（克制：用节点而非大图） */}
              <div className="mt-4 flex items-center">
                {d.steps.map((s, i) => (
                  <div key={s} className="flex flex-1 items-center last:flex-none">
                    <div className="flex flex-col items-center text-center">
                      <span className="flex h-5 w-5 items-center justify-center rounded-full bg-band text-[10px] font-bold text-verm ring-1 ring-line">
                        {i + 1}
                      </span>
                      <span className="mt-1 hidden max-w-[70px] text-center text-[10px] leading-tight text-ink/50 lg:block">{s}</span>
                    </div>
                    {i < d.steps.length - 1 && <span className="mx-1 h-px flex-1 bg-line" />}
                  </div>
                ))}
              </div>

              <a href="#diagram" className="mt-4 flex items-center justify-center gap-1 border-t border-dashed border-line pt-3 text-sm font-semibold text-verm hover:opacity-75">
                查看完整图解 <i className="ri-arrow-right-up-line" />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}